var map = {
	"./decidim/avatar-multiuser.png": 59587,
	"./decidim/brands/facebook.svg": 7595,
	"./decidim/brands/google.svg": 29730,
	"./decidim/brands/twitter-x.svg": 46211,
	"./decidim/cc-badge.png": 34913,
	"./decidim/decidim-logo.svg": 98993,
	"./decidim/default-avatar.svg": 74481,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 64391,
	"./decidim/icons.svg": 18288,
	"./decidim/pattern.png": 70547,
	"./decidim/placeholder-card-g.svg": 720,
	"./decidim/placeholder-card-l.svg": 10779,
	"./decidim/placeholder.jpg": 66098,
	"./decidim/remixicon.symbol.svg": 75976,
	"./decidim/vendor/social-share-button/douban.svg": 50075,
	"./decidim/vendor/social-share-button/email.svg": 82356,
	"./decidim/vendor/social-share-button/facebook.svg": 91632,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 72996,
	"./decidim/vendor/social-share-button/hacker_news.svg": 98424,
	"./decidim/vendor/social-share-button/linkedin.svg": 18674,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 49083,
	"./decidim/vendor/social-share-button/pinterest.svg": 46482,
	"./decidim/vendor/social-share-button/reddit.svg": 64456,
	"./decidim/vendor/social-share-button/telegram.svg": 68029,
	"./decidim/vendor/social-share-button/tumblr.svg": 95642,
	"./decidim/vendor/social-share-button/twitter.svg": 22129,
	"./decidim/vendor/social-share-button/vkontakte.svg": 82299,
	"./decidim/vendor/social-share-button/wechat.svg": 646,
	"./decidim/vendor/social-share-button/whatsapp.svg": 61310,
	"./decidim/vendor/social-share-button/x.svg": 1964,
	"./decidim/vendor/social-share-button/xing.svg": 58156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99422;